import { makeStyles, Theme } from '@material-ui/core';
import { style } from 'commons/constants/KeyFlowConstants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: '0 0 20px 0',
    '& input, & button': {
      fontSize: '14px',
    },
  },
  right: {
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end',
    },
  },
  inputTitleContainer: {
    backgroundColor: 'transparent',
  },
  inputPartialTitle: {
    padding: '10px',

    width: '100%',
    height: '49px',

    backgroundColor: 'transparent',

    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    borderBottom: '0px solid',
    outline: 'none',

    color: '#ffffff',
    '&::placeholder': {
      fontSize: '14px',
      color: '#ffffff',
    },
  },
  inputTimeContainer: {
    display: 'flex',
  },
  timeGroupContainer: {
    display: 'flex',
    height: '36px',
    margin: '0 6px 0 0',
    '& > div': {
      position: 'relative',
    },
    [theme.breakpoints.down('md')]: {
      width: '50%',
      margin: '0',
    },
  },
  inputTime: {
    position: 'relative',
    width: '44px',
    height: '36px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  upDownButtonContainer: {
    position: 'absolute',
    top: 0,
    right: '2px',
    display: 'flex',
    flexDirection: 'column',
    padding: '2px 0',
    height: '36px',
  },
  upDownIcon: {
    '&:hover': {
      cursor: 'pointer',
      color: style.PINK_COLOR,
    },
    '& > svg': {
      fontSize: '14px',
    },
  },
  timeButton: {
    width: '62px',
    margin: '0 2px 0 0',
    backgroundColor: 'gray',
    outline: 'none',
    border: '0px',
    color: '#ffffff',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      width: '24.5%',
      minWidth: '47px',
    },
  },
  buttonContainer: {
    height: '36px',

    '& > button': {
      color: '#ffffff',
      backgroundColor: style.PINK_COLOR,
      borderRadius: 0,
    },
    '& > button:not(:first-child)': {
      borderLeft: `2px solid ${style.PREVIEW_CONTENTS_BACKGROUND_COLOR}`,
    },
    [theme.breakpoints.down('md')]: {
      margin: '10px 0 0 0',
    },
  },
}));

export default useStyles;
